import {
  ADD_SETTINGS,
  DELETE_SETTING,
  DELETE_SETTINGS,
  SET_SETTINGS,
  SettingsAction,
} from "../types";
import { Setting, Settings } from "../../types";

export const setSettings = (settings: Settings): SettingsAction => {
  return {
    type: SET_SETTINGS,
    payload: settings,
  };
};

export const addSetting = (setting: Setting): SettingsAction => {
  return {
    type: ADD_SETTINGS,
    payload: setting,
  };
};

export const deleteSettings = (): SettingsAction => {
  return {
    type: DELETE_SETTINGS,
  };
};

export const deleteSetting = (setting: string): SettingsAction => {
  return {
    type: DELETE_SETTING,
    payload: setting,
  };
};
